/**
 * @Author: Roni Laukkarinen
 * @Date:   2022-12-31 00:21:23
 * @Last Modified by:   Michael Bourne
 * @Last Modified time: 2023-03-09 12:19:32
 */
// Calculate burger menu position and mobile nav dimensions
function calculateBurgerMenuPosition() {
  // If nav-toggle, site-header or menu-items-wrapper not found, bail
  if (!document.getElementById('nav-toggle') || !document.querySelector('.site-header') || !document.getElementById('menu-items-wrapper')) {
    // eslint-disable-next-line no-console
    console.log('Warning: No nav-toggle, site-header, or menu-items-wrapper found.');

    return;
  }

  // Set viewport
  const viewportWidth = document.documentElement.clientWidth || document.body.clientWidth;

  // Get --width-max-mobile from CSS
  const widthMaxMobile = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--width-max-mobile'), 10);

  // Only apply mobile nav calculations on mobile viewport
  if (viewportWidth >= widthMaxMobile) {
    return;
  }

  // Get the height of .site-header
  const siteHeader = document.querySelector('.site-header');
  const siteHeaderHeight = siteHeader.offsetHeight;

  // Set CSS custom property for header height
  document.documentElement.style.setProperty('--site-header-height', `${siteHeaderHeight}px`);

  // Set the mobile menu wrapper position and height
  const menuWrapper = document.getElementById('menu-items-wrapper');
  menuWrapper.style.top = `${siteHeaderHeight}px`;
  // menuWrapper.style.height = `calc(100vh - ${siteHeaderHeight}px)`;
}

export default calculateBurgerMenuPosition;
